<template>
  <div>
    <h1>Vos identifiants.</h1>
    <form @submit.prevent="handleSubmit">
      <FormInput
        id="register-email"
        v-model="form.email"
        label="Adresse email"
        required
        type="email"
        @blur="$v.form.email.$touch()"
        @input="emailAlreadyUsed = false"
      >
        <template v-if="$v.form.email.$dirty" #error>
          <template v-if="emailAlreadyUsed">Adresse email déjà utilisée</template>
          <template v-else-if="!$v.form.email.required">Adresse email obligatoire</template>
          <template v-else-if="$v.form.email.$invalid">Adresse email invalide</template>
        </template>
      </FormInput>
      <FormInput
        id="register-password"
        v-model="form.password"
        :show-password="showPassword"
        label="Mot de passe"
        required
        type="password"
        @blur="$v.form.password.$touch()"
        @toggle-password-visibility="showPassword = !showPassword"
      >
        <template #help>Doit contenir au minimum 8 caractères</template>
        <template v-if="$v.form.password.$dirty" #error>
          <template v-if="!$v.form.password.required">Mot de passe obligatoire</template>
          <template v-else-if="!$v.form.password.minLength">8 caractères minimum</template>
        </template>
      </FormInput>

      <DashedLine />

      <div class="information">Si vous disposez d'un code de réduction vous pouvez le renseigner dans le champ ci-dessous.</div>
      <FormInput
        id="discount_code"
        label="Ajouter mon code de promotion"
        v-model="form.discountCode"
      />

      <DashedLine />

      <FormCheckbox v-model="form.acceptTerms" class="accept-terms">
        <template #default>
          J’ai lu et j’accepte la
          <a :href="$setting('PRIVACY_LINK')" target="_blank">Politique de Confidentialité</a>
          ainsi que les
          <a :href="$setting('TERMS_LINK')" target='_blank'>Conditions Générales d’Utilisation</a>
        </template>
        <template v-if="$v.form.acceptTerms.$dirty" #error>
          <template v-if="$v.form.acceptTerms.$invalid">Vous devez accepter les conditions générales</template>
        </template>
      </FormCheckbox>

      <SignupButtons :can-be-submitted="!$v.$invalid" :is-submitting="isSubmitting" />
    </form>
  </div>
</template>

<script>
  import ButtonGreen from '@/components/ButtonGreen';
  import FormInput from '@/components/Form/FormInput';
  import DashedLine from '@/components/DashedLine';
  import FormCheckbox from '@/components/Form/FormCheckbox';
  import SignupButtons from '@/components/Signup/SignupButtons';
  import { email, minLength, required } from '@byscripts/vuelidate/lib/validators';
  import Auth from '@/api/auth';

  export default {
    name: 'SignupAuthentication',
    components: { SignupButtons, FormCheckbox, DashedLine, FormInput, ButtonGreen },
    data() {
      return {
        emailAlreadyUsed: false,
        showPassword: true,
        isSubmitting: false,
        form: {
          email: this.$store.state.signup.form.email,
          password: this.$store.state.signup.form.password,
          discountCode: this.$store.state.signup.form.discountCode,
          acceptTerms: this.$store.state.signup.form.acceptTerms || false,
        },
      };
    },
    validations: {
      form: {
        email: {
          required,
          email,
        },
        password: {
          required,
          minLength: minLength(8),
        },
        acceptTerms: {
          required,
          true: (v) => v === true,
        },
      },
    },
    methods: {
      async handleSubmit() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return this.$addError('Veuillez vérifier le formulaire');
        }

        try {
          this.isSubmitting = true;
          this.emailAlreadyUsed = false;
          this.showPassword = false;

          await Auth.checkIfEmailExists(this.form.email);

          await this.$store.dispatch('signup/saveForm', { form: this.form });
          await this.$store.dispatch('auth/setCredentials', { email: this.form.email, password: this.form.password });
          await this.$store.dispatch('signup/goToNextStep');
        } catch (e) {
          if (e?.response?.status === 400) {
            this.emailAlreadyUsed = true;
          } else {
            throw e;
          }
        } finally {
          this.isSubmitting = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-input {
    margin-bottom: 3rem;
  }

  .information {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .accept-terms {
    font-size: 1.4rem;
    margin-top: 4rem;
    color: $fadedTextColor;

    a {
      color: $fadedTextColor
    }
  }

  .dashed-line {
    margin: 4rem 0 3rem;
  }
  ::v-deep .signup-buttons.has-back-button{
    @include onMobile{
      column-gap: 3.7rem;
      justify-content: end;
      flex-wrap: wrap;
    }
  }
</style>
